import _createForOfIteratorHelper from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.trim.js";
//
//
//

import { getToken } from '@/utils/auth';
// get token from cookie
export default {
  data: function data() {
    return {
      fullscreenLoading: false,
      urlPath: this.getUrlPath(),
      token: null,
      iframeRefs: '',
      observer: null
    };
  },
  created: function created() {
    this.fullscreenLoading = true;
    this.token = "access_token=".concat(getToken());
    var src = this.$route.query.src;
    if (src) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'iframeUrl',
        value: src
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.iframeRefs = this.$refs.iframe;
    this.changeIframeUrl(this.getIframUrl);
    this.iframeInit();
    this.iframeRefs.onload = function () {
      _this.restoreIframeNav(_this.getIframUrl);
      _this.urlObserver();
    };
    window.onresize = function () {
      _this.iframeInit();
    };
  },
  props: ['routerPath'],
  watch: {
    routerPath: function routerPath() {
      this.urlPath = this.getUrlPath();
    },
    '$store.state.settings.iframeUrl': {
      handler: function handler(val) {
        var _this2 = this;
        if (!val) return;
        this.$nextTick(function () {
          _this2.changeIframeUrl(val);
        });
      }
    }
  },
  computed: {
    getIframUrl: function getIframUrl() {
      if (this.$store.state.settings.iframeUrl === null || this.$store.state.settings.iframeUrl === '' || this.$store.state.settings.iframeUrl === undefined) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$router.push({
          path: '/404'
        });
        return;
      }
      if (this.$store.state.settings.iframeUrl.indexOf('?') > -1) {
        return "".concat(this.$store.state.settings.iframeUrl);
      } else {
        return "".concat(this.$store.state.settings.iframeUrl);
      }
    }
  },
  components: {},
  destroyed: function destroyed() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    iframeInit: function iframeInit() {
      var iframe = this.iframeRefs;
      var clientHeight = document.documentElement.clientHeight - 64;
      if (iframe && iframe.style) {
        iframe.style.height = "".concat(clientHeight, "px");
      }
      // if (iframe.attachEvent) {
      //   iframe.attachEvent('onload', () => {
      //     this.fullscreenLoading = false
      //   })
      // } else {
      //   iframe.onload = () => {
      //     this.fullscreenLoading = false
      //   }
      // }
      // window.history.replaceState(null,null,window.location.origin);
    },
    // 修改iframe的src 且不在历史记录中留下记录
    changeIframeUrl: function changeIframeUrl(val) {
      var iframeWindow = this.$refs.iframe.contentWindow;
      var currentHref = iframeWindow.location.href;
      var isFirstTimeEnterIframe = currentHref.length === 0 || currentHref === 'about:blank';
      if (isFirstTimeEnterIframe || currentHref !== val) {
        iframeWindow.location.replace(val);
      }
    },
    // 监听 iframe内部src 变化 (只有在内部点击或者浏览器前进后退时才会触发)
    urlObserver: function urlObserver() {
      var _this3 = this;
      var iframe = this.iframeRefs;
      var observer = new MutationObserver(function () {
        var currentUrl = iframe.contentWindow.location.href;
        var lastUrl = _this3.$store.state.settings.iframeUrl;
        if (currentUrl !== lastUrl) {
          console.log('currentUrl:', currentUrl);
          _this3.$store.dispatch('settings/changeSetting', {
            key: 'iframeUrl',
            value: currentUrl
          });
          _this3.$router.replace({
            query: {
              iframePath: currentUrl
            }
          });
          _this3.restoreIframeNav(currentUrl);
          _this3.setTitleFromBreadcrumb();
        }
      });
      if (!observer) return;
      try {
        if (!iframe.contentDocument) throw new Error('读取iframeUrl失败');
        observer.observe(iframe.contentDocument, {
          childList: true,
          subtree: true
        });
        this.observer = observer;
      } catch (error) {
        console.error('Failed to observe iframe URL:', error);
        this.$router.replace({
          path: '/404'
        });
      }
    },
    restoreIframeNav: function restoreIframeNav(path) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var menuArr, defaultActiveMenu;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                path = path.split('?')[0];
                // 从iframe内部获取当前路径，设置默认菜单
                _context.next = 3;
                return _this4.getMenuArrPromise();
              case 3:
                menuArr = _context.sent;
                defaultActiveMenu = _this4.findMenuItem(menuArr, path);
                if (defaultActiveMenu) {
                  _context.next = 9;
                  break;
                }
                _this4.setTitleFromBreadcrumb();
                _this4.setNavFromBreadcrumb();
                return _context.abrupt("return");
              case 9:
                document.title = '智能合规平台';
                _this4.$store.dispatch('settings/changeSetting', {
                  key: 'index',
                  value: defaultActiveMenu === null || defaultActiveMenu === void 0 ? void 0 : defaultActiveMenu.resourceId
                });
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 监听菜单数组变化
    getMenuArrPromise: function getMenuArrPromise() {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        // 如果菜单数组已经存在，立即返回
        if (_this5.$store.getters.menuArr.length > 0) {
          resolve(_this5.$store.getters.menuArr);
          return;
        }

        // 创建一个可以清理的监听器
        var unwatch;
        var dataPromise = new Promise(function (resolve) {
          unwatch = _this5.$watch(function () {
            return _this5.$store.getters.menuArr;
          }, function (newMenuArr) {
            if (newMenuArr.length > 0) {
              unwatch();
              resolve(newMenuArr);
            }
          }, {
            deep: true
          });
        });

        // 设置一个超时的 Promise
        var timeoutPromise = new Promise(function (resolve) {
          setTimeout(function () {
            if (unwatch) unwatch(); // 清理监听器
            resolve([]);
          }, 10000);
        });

        // 使用 Promise.race 来处理两个 Promise
        Promise.race([dataPromise, timeoutPromise]).then(resolve).catch(reject);
      });
    },
    findMenuItem: function findMenuItem(menuArr, path) {
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'path';
      // 递归查找菜单项
      var _iterator = _createForOfIteratorHelper(menuArr),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item[key] === path) return item;
          var foundItem = item.children && this.findMenuItem(item.children, path, key);
          if (foundItem) return foundItem;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    },
    getUrlPath: function getUrlPath() {
      var url = window.location.href;
      url = url.replace('/iframe', '');
      return url;
    },
    setTitleFromBreadcrumb: function setTitleFromBreadcrumb() {
      var _elBreadcrumb$querySe;
      // 有的内部页面在router中没有title，所以需要从面包屑中获取
      var iframe = this.iframeRefs;
      var iframeDocument = (iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) || (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow.document);
      if (!iframeDocument) return;
      // Element UI
      var elBreadcrumb = iframeDocument.querySelector('.el-breadcrumb__item[aria-current="page"]');
      var elBreadcrumbText = elBreadcrumb === null || elBreadcrumb === void 0 ? void 0 : (_elBreadcrumb$querySe = elBreadcrumb.querySelector('.el-breadcrumb__inner')) === null || _elBreadcrumb$querySe === void 0 ? void 0 : _elBreadcrumb$querySe.innerText;

      // Ant Design
      var antBreadcrumbText;
      if (!elBreadcrumb) {
        var _antBreadcrumbs;
        var antBreadcrumbs = iframeDocument.querySelectorAll('.ant-breadcrumb-link');
        antBreadcrumbText = (_antBreadcrumbs = antBreadcrumbs[antBreadcrumbs.length - 1]) === null || _antBreadcrumbs === void 0 ? void 0 : _antBreadcrumbs.innerText;
      }
      var breadcrumbActiveText = elBreadcrumbText || antBreadcrumbText;
      if (!breadcrumbActiveText) return;
      document.title = "\u667A\u80FD\u5408\u89C4\u5E73\u53F0";
    },
    setNavFromBreadcrumb: function setNavFromBreadcrumb() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _iframe$contentWindow;
        var iframe, iframeDocument, breadcrumbs, breadcrumbsTexts, menuArr, findItem;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                iframe = _this6.iframeRefs;
                iframeDocument = (iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) || (iframe === null || iframe === void 0 ? void 0 : (_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 ? void 0 : _iframe$contentWindow.document);
                if (iframeDocument) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return");
              case 4:
                breadcrumbs = [];
                breadcrumbsTexts = []; // 尝试获取 Element UI 面包屑
                breadcrumbs = Array.from(iframeDocument.querySelectorAll('.el-breadcrumb__item'));
                if (breadcrumbs.length) {
                  breadcrumbsTexts = breadcrumbs.map(function (item) {
                    var _item$querySelector, _item$querySelector$i;
                    return (_item$querySelector = item.querySelector('.el-breadcrumb__inner')) === null || _item$querySelector === void 0 ? void 0 : (_item$querySelector$i = _item$querySelector.innerText) === null || _item$querySelector$i === void 0 ? void 0 : _item$querySelector$i.replace(/\s*\/\s*$/, '').trim();
                  }).filter(Boolean);
                }

                // 如果没有找到 Element UI 面包屑，尝试获取 Ant Design 面包屑
                if (!breadcrumbsTexts.length) {
                  breadcrumbs = Array.from(iframeDocument.querySelectorAll('.ant-breadcrumb-link'));
                  breadcrumbsTexts = breadcrumbs.map(function (item) {
                    var _item$querySelector2;
                    return ((_item$querySelector2 = item.querySelector('a')) === null || _item$querySelector2 === void 0 ? void 0 : _item$querySelector2.innerText) || item.textContent;
                  }).map(function (text) {
                    return text === null || text === void 0 ? void 0 : text.replace(/\s*\/\s*$/, '').trim();
                  }).filter(Boolean);
                }
                if (breadcrumbsTexts.length) {
                  _context2.next = 11;
                  break;
                }
                return _context2.abrupt("return");
              case 11:
                _context2.next = 13;
                return _this6.getMenuArrPromise();
              case 13:
                menuArr = _context2.sent;
                findItem = _this6.findMenuItemFromBreadcrumbs(menuArr, breadcrumbsTexts);
                if (findItem) {
                  _this6.$store.dispatch('settings/changeSetting', {
                    key: 'index',
                    value: findItem.resourceId
                  });
                }
              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 辅助方法，用于从面包屑中从后往前查找菜单项
    findMenuItemFromBreadcrumbs: function findMenuItemFromBreadcrumbs(menuArr, breadcrumbsTexts) {
      for (var i = breadcrumbsTexts.length - 1; i >= 0; i--) {
        var text = breadcrumbsTexts[i];
        var findItem = this.findMenuItem(menuArr, text, 'resourceName');
        if (findItem) return findItem;
      }
      return null;
    }
  }
};